import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RoleCode } from '../../../../../domain/consts';
import { SalespointDocument } from '../../../../../domain/document.model';
import { Party, PartyType } from '../../../../../domain/party.domain';
import { SystemUser } from '../../../../../domain/user.model';
import { DialogAction } from '../../../store/dialog.action';
import { OfferAction } from '../../../store/offer.action';
import { UserState } from '../../../store/user.state';

@Component({
    selector: 'app-clients-summary-box',
    templateUrl: './clients-summary-box.component.html',
    styleUrls: ['./clients-summary-box.component.scss']
})
export class ClientsSummaryBoxComponent implements OnInit {

    @Select(UserState.getUser) user$: Observable<SystemUser>;
    @Input() document: SalespointDocument;
    @Input() readonly = false;

    get phoneNumber() {
        const contactData = this.document.additionalData.contactData;
        return `${contactData.phonePrefix || ''} ${contactData.phoneNumber || ''}`.trim();
    }

    get partyList(): Party[] {
        const used = [this.policyholderId];
        const result: Party[] = [this.document.partyList.find(p => p.id === this.policyholderId)];
        this.document.partyList.forEach(p => {
            if (used.indexOf(p.id) === -1) {
                result.push(p);
                used.push(p.id);
            }
        });
        return result.filter(e => e);
    }

    get policyholderId() {
        const role = this.document.partyRoleList.find(e => e.role === RoleCode.POLICYHOLDER);
        return role
            ? role.partyId
            : null;
    }

    get isPolicyholderInsured() {
        const policyholderId = this.policyholderId;
        return this.document.partyRoleList
            .filter(e => e.partyId === policyholderId && e.role === RoleCode.INSURED_PERSON).length > 0;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
    }

    personLabel(person: Party) {
        if (person.id === this.policyholderId) {
            return this.isPolicyholderInsured
                ? 'LABEL.POLICYHOLDER_INSURED'
                : 'LABEL.POLICYHOLDER';
        }
        return 'LABEL.INSURED';
    }

    personAddressLabel(person: Party) {
        if(person.typeCode === PartyType.LEGAL){
            return 'LABEL.ADDRESS_CORESPONDENCE';
        }
        return person.otherCorrespondenceAddress
            ? 'LABEL.ADDRESS'
            : 'LABEL.BOTH_ADDRESSES';
    }

    editContactData() {
        this.store.dispatch(new DialogAction.OpenContactDataDialog(this.document.id, this.document.additionalData.contactData));
    }

    get emptyContactData() {
        return !this.document.additionalData.contactData
            || (!this.document.additionalData.contactData.email && !this.document.additionalData.contactData.phoneNumber);
    };

    deleteContactData() {
        this.store.dispatch(new OfferAction.DeleteContactData(this.document.id));
    }
}
